import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const UserAssets = ({
    assets = [],
    onSelect,
    containerStyle = {}
}) => {

    return (
        <Box
            sx={{
                borderRadius: 1,
                p: 1,
                maxHeight: 300,
                overflowY: "auto",
                backgroundColor: "#fafafa",
                ...containerStyle
            }}
        >
            {assets.length === 0 ? (
                <Typography fontSize={14}>No assets found.</Typography>
            ) : (
                assets.map((asset) => (
                    <Box
                        key={asset.userAssetId}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 0.5,
                            p: 0.6,
                            borderRadius: 1,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#eeeeee"
                            }
                        }}
                        onClick={() => {
                            if (onSelect) {
                                onSelect({
                                    id: asset.assetActivityId,
                                    name: asset.assetName
                                });
                            }
                        }}
                    >
                        <Typography fontSize={14}>
                            {asset.assetName}
                        </Typography>
                    </Box>
                ))
            )}
        </Box>
    );
};

export default UserAssets;